import { createContext, useContext } from 'react';

const CursorStateContext = createContext<boolean>(false);

export default CursorStateContext;

export function useIsCursorVisible(): boolean {
  return useContext(CursorStateContext);
}
